import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Legal.module.css';
import { Logo } from '../../components/ui';

/**
 * Shared chrome for /terms and /privacy: header, draft banner, document body.
 *
 * Both documents are unreviewed drafts, so the banner is part of the shared
 * layout rather than something each page opts into — that way a new legal page
 * cannot accidentally ship without the warning.
 */
export function LegalPage({ title, updated, children }) {
  useEffect(() => {
    document.title = `${title} — Don Quack`;
  }, [title]);

  return (
    <div className={styles.page}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <Link to="/" aria-label="Don Quack home">
            <Logo size={30} />
          </Link>
          <Link to="/" className={styles.back}>
            &larr; Back to the site
          </Link>
        </div>

        <h1 className={styles.title}>{title}</h1>
        <p className={styles.updated}>Last updated: {updated}</p>

        <div className={styles.banner}>
          <p className={styles.bannerTitle}>Draft template — not yet legally reviewed</p>
          <p className={styles.bannerBody}>
            This document is a working template prepared for Don Quack. It has
            not been reviewed by a qualified lawyer, and the highlighted fields
            still need real values. Do not treat it as final or as legal advice.
          </p>
        </div>

        <div className={styles.doc}>{children}</div>

        <p className={styles.footerNote}>
          Questions about this document? Contact us at{' '}
          <Fill>legal@donquack.com</Fill>.
        </p>
      </div>
    </div>
  );
}

/** Marks a value the operator still has to supply. */
export function Fill({ children }) {
  return <span className={styles.fill}>{children}</span>;
}
